import React, { useState } from "react";
import spiral from "../components/biomanthan/images/spiral.png"
import { ContactSection } from "./biomanthan/sections/contact-section";
import { SponsorsSection } from "./biomanthan/sections/sponsors-section";
import { RegistrationSection } from "./biomanthan/sections/registration-section";
import { PublicationsSection } from "./biomanthan/sections/publications-section";
import { SpeakersSection } from "./biomanthan/sections/speakers-section";
import { OverviewSection } from "./biomanthan/sections/overview-section";
import { ThemesSection } from "./biomanthan/sections/themes-section";
import { WorkshopsSection } from "./biomanthan/sections/workshops-section";
import { ScheduleSection } from "./biomanthan/sections/schedule-section";
export default function BiomanthanPage() {
  const [current, setCurrent] = useState("overview");
  const baseId = "tabs";

  return (
    <main className="min-h-dvh pt-20 bg-white">
      {/* Hero */}
      <header className="relative overflow-hidden">
        <div className="absolute inset-0 pointer-events-none opacity-20" aria-hidden="true">
          <div className="h-full w-full bg-[radial-gradient(ellipse_at_top,theme(colors.primary/20),transparent_60%)]" />
        </div>
        {/* flex lg:flex lg:justify-between flex-wrap justify-center gap-8 items-center */}
        <div className="relative max-w-7xl mx-auto px-10 md:px-6 lg:px-8 py-10 md:py-14">
          <div className="flex lg:flex lg:justify-between flex-wrap justify-center gap-8 items-center">
            <div className="space-y-4">
              <p className="text-sm uppercase tracking-widest text-muted-foreground">40th International Conference</p>
              <h1 className="text-3xl md:text-5xl font-semibold text-balance">BioMANTHAN 2025</h1>
              <p className="text-pretty text-muted-foreground">
                Organized by SBAOI & STERMI at Indian Institute of Technology (IIT) Ropar, Punjab, India.
              </p>
              <div className="flex flex-wrap gap-3 pt-2">
                <span className="inline-flex items-center rounded-md border px-3 py-1.5 text-sm">Dec’ 4–7, 2025</span>
                <span className="inline-flex items-center rounded-md border px-3 py-1.5 text-sm">Chandigarh • Punjab</span>
                <a
                  href="http://www.iitrpr.ac.in/biomanthan/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex bg-sky-500 text-white items-center rounded-md bg-primary text-primary-foreground px-3 py-1.5 text-sm hover:opacity-90"
                >
                  Register now
                </a>
              </div>
            </div>

            <div className="rounded-lg border bg-muted/30 p-3">
              <img
                src={spiral}
                alt="Conference hero placeholder"
                className="w-96 h-auto rounded-md"
              />
              
            </div>
          </div>
        </div>
      </header>

      {/* Tabs */}
      <nav
        className="sticky top-0 z-10 bg-background/80 backdrop-blur border-b"
        role="tablist"
        aria-label="Program sections"
      >
        <div className="max-w-7xl mx-auto px-10 md:px-6 lg:px-8">
          <div className="flex flex-wrap justify-center items-center gap-8 py-3">
            {[
              "overview",
              "themes",
              "workshops",
              "schedule",
              "speakers",
              "publications",
              "registration",
              "sponsors",
              "contact",
            ].map((tab) => {
              const selected = current === tab;
              return (
                <button
                  key={tab}
                  role="tab"
                  id={`${baseId}-tab-${tab}`}
                  aria-selected={selected}
                  aria-controls={`${baseId}-panel-${tab}`}
                  onClick={() => setCurrent(tab)}
                  className={[
                    "px-3 py-1.5 rounded-md text-sm transition-colors border",
                    selected
                      ? "bg-primary bg-sky-500 text-white text-primary-foreground border-primary"
                      : "bg-muted text-muted-foreground hover:text-foreground hover:border-foreground/30 border-transparent",
                  ].join(" ")}
                >
                  {tab.charAt(0).toUpperCase() + tab.slice(1)}
                </button>
              );
            })}
          </div>
        </div>
      </nav>

      {/* Panels */}
      <div className="max-w-7xl mx-auto px-4 md:px-6 lg:px-8">
        {/* Overview */}
        <section
          role="tabpanel"
          id={`${baseId}-panel-overview`}
          aria-labelledby={`${baseId}-tab-overview`}
          hidden={current !== "overview"}
          className={`py-8 md:py-10 transition-opacity duration-300 ${current === "overview" ? "opacity-100" : "opacity-0"}`}
        >
          <OverviewSection/>
        </section>

        {/* Themes */}
        <section
          role="tabpanel"
          id={`${baseId}-panel-themes`}
          aria-labelledby={`${baseId}-tab-themes`}
          hidden={current !== "themes"}
          className={`py-8 md:py-10 transition-opacity duration-300 ${current === "themes" ? "opacity-100" : "opacity-0"}`}
        >
          <ThemesSection/>
        </section>

        {/* Workshops */}
        <section
          role="tabpanel"
          id={`${baseId}-panel-workshops`}
          aria-labelledby={`${baseId}-tab-workshops`}
          hidden={current !== "workshops"}
          className={`py-8 md:py-10 transition-opacity duration-300 ${current === "workshops" ? "opacity-100" : "opacity-0"}`}
        >
          <WorkshopsSection/>
        </section>

        {/* Schedule */}
        <section
          role="tabpanel"
          id={`${baseId}-panel-schedule`}
          aria-labelledby={`${baseId}-tab-schedule`}
          hidden={current !== "schedule"}
          className={`py-8 md:py-10 transition-opacity duration-300 ${current === "schedule" ? "opacity-100" : "opacity-0"}`}
        >
          <ScheduleSection/>
        </section>

        {/* Speakers */}
        <section
          role="tabpanel"
          id={`${baseId}-panel-speakers`}
          aria-labelledby={`${baseId}-tab-speakers`}
          hidden={current !== "speakers"}
          className={`py-8 md:py-10 transition-opacity duration-300 ${current === "speakers" ? "opacity-100" : "opacity-0"}`}
        >
          <div className="space-y-6">
            <h2 className="text-2xl md:text-3xl font-semibold">Speakers</h2>
            <SpeakersSection/>
          </div>
        </section>

        {/* Publications */}
        <section
          role="tabpanel"
          id={`${baseId}-panel-publications`}
          aria-labelledby={`${baseId}-tab-publications`}
          hidden={current !== "publications"}
          className={`py-8 md:py-10 transition-opacity duration-300 ${current === "publications" ? "opacity-100" : "opacity-0"}`}
        >
          <PublicationsSection/>
        </section>

        {/* Registration */}
        <section
          role="tabpanel"
          id={`${baseId}-panel-registration`}
          aria-labelledby={`${baseId}-tab-registration`}
          hidden={current !== "registration"}
          className={`py-8 md:py-10 transition-opacity duration-300 ${current === "registration" ? "opacity-100" : "opacity-0"}`}
        >
          <RegistrationSection/>
        </section>

        {/* Sponsors */}
        <section
          role="tabpanel"
          id={`${baseId}-panel-sponsors`}
          aria-labelledby={`${baseId}-tab-sponsors`}
          hidden={current !== "sponsors"}
          className={`py-8 md:py-10 transition-opacity duration-300 ${current === "sponsors" ? "opacity-100" : "opacity-0"}`}
        >
          <SponsorsSection/>
        </section>

        {/* Contact */}
        <section
          role="tabpanel"
          id={`${baseId}-panel-contact`}
          aria-labelledby={`${baseId}-tab-contact`}
          hidden={current !== "contact"}
          className={`py-8 md:py-10 transition-opacity duration-300 ${current === "contact" ? "opacity-100" : "opacity-0"}`}
        >
          <ContactSection/>
        </section>
      </div>

      {/* Footer */}
      <footer className="border-t mt-8">
        <div className="max-w-7xl mx-auto px-4 md:px-6 lg:px-8 py-8 text-sm text-muted-foreground">
          <p className="text-pretty">
            BioMANTHAN 2025 • 40th International Conference • Organized by SBAOI & STERMI at IIT Ropar, Punjab, India
          </p>
        </div>
      </footer>
    </main>
  );
}
